import { Box, Button, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { deletePromocion, type Promocion } from "../../firebase/firestore/promociones";
import { usePromocionStore } from "../../zustand/usePromocionesStore";
import Modal from "./Modal";

interface ModalDeletePromocionProps {
  isOpen: boolean;
  onClose: () => void;
  promocion?: Promocion;
}

export default function ModalDeletePromocion({
  isOpen,
  onClose,
  promocion,
}: ModalDeletePromocionProps) {
  const { fetchAllPromociones } = usePromocionStore();

  const handleDelete = async () => {
    if (!promocion) return;

    try {
      await deletePromocion(promocion.id);
      toast.success("Promoción eliminada exitosamente");
      onClose();
      await fetchAllPromociones();
    } catch (error) {
      console.error("Error eliminando promoción:", error);
      toast.error("Error al eliminar la promoción. Intente nuevamente");
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Eliminar promoción"
      content={
        <Box
          sx={{
            paddingX: "24px",
            marginBottom: 2,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Typography>
            {promocion
              ? `La promoción "${promocion.titulo}" será eliminada permanentemente. ¿Estás seguro que deseas continuar?`
              : "¿Estás seguro que deseas eliminar esta promoción?"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button onClick={onClose} variant="outlined" size="small">
              Cancelar
            </Button>
            <Button
              onClick={handleDelete}
              variant="contained"
              color="error"
              size="small"
            >
              Eliminar
            </Button>
          </Box>
        </Box>
      }
      sx={{
        marginX: "auto",
        width: {
          xs: "90%",
          sm: "50%",
        },
      }}
    />
  );
}
